import { COLORS, Tooltip } from '@monthio/react-components'
import React, { FunctionComponent, useEffect, useState } from 'react'
import styled from 'styled-components'
import { localOverridesService } from '../localOverridesServices'

const Container = styled.div`
	position: fixed;
	top: 0;
	z-index: 9000;
`
type Status = 'none' | 'partial' | 'all-up' | 'all-down'
const Dot = styled.div<{ $status: Status }>`
	pointer-events: all;
	height: 20px;
	width: 20px;
	padding: 20px;
	margin: 10px;
	border-radius: 25px;
	background-color: ${(props) => {
		switch (props.$status) {
			case 'partial':
				return COLORS.OTHER_COLORS.BRIGHT_YELLOW
			case 'none':
				return COLORS.GREY_SCALE.DARK_DETAIL_GREY
			case 'all-up':
				return COLORS.OTHER_COLORS.AFFIRMATION_GREEN
			case 'all-down':
				return COLORS.OTHER_COLORS.ERROR_RED
			default:
				return COLORS.OTHER_COLORS.BRIGHT_BLUE
		}
	}};
`

export const LocalOverridesDot: FunctionComponent<{
	children?: never
}> = () => {
	const [tooltipText, setTooltipText] = useState('no overrides is active')
	const [status, setStatus] = useState<Status>('none')
	useEffect(() => {
		const subscription = localOverridesService.update.subscribe((update) => {
			if (update.length === 0) {
				setStatus('none')
				setTooltipText('no overrides is active')
				return
			}

			if (update.every((v) => v.overrideUp)) {
				const text = update
					.map(
						(value) => `${value.appId} is ${value.overrideUp ? 'up' : 'down'}`,
					)
					.join('\n')
				setStatus('all-up')
				setTooltipText(text)
				return
			}

			if (update.some((v) => v.overrideUp)) {
				const text = update
					.map(
						(value) => `${value.appId} is ${value.overrideUp ? 'up' : 'down'}`,
					)
					.join('\n')
				setStatus('partial')
				setTooltipText(text)
				return
			}

			const text = update
				.map((value) => `${value.appId} is ${value.overrideUp ? 'up' : 'down'}`)
				.join('\n')
			setStatus('all-down')
			setTooltipText(text)
		})

		return () => {
			subscription.unsubscribe()
		}
	}, [])

	return (
		<Container>
			<Tooltip title={<pre>{tooltipText}</pre>}>
				<Dot $status={status} onClick={localOverridesService.updateStatus} />
			</Tooltip>
		</Container>
	)
}
